import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiListItemButton = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      gap: '10px',
      borderRadius: '10px',
      paddingBlock: '8px',
      paddingInline: '10px',
    },
  },
} satisfies Components<Theme>['MuiListItemButton'];
